export default __webpack_public_path__ + "static/media/battle_win_preview.1edace78.png";